module.exports = __webpack_public_path__ + "img/handshake.8c72fd0.jpg";